import classnames from 'classnames'
import React from 'react'

// Utils

import IButton from '@src/quince-site-common/src/icons/iButtton.inline.svg'

import { TOP_TIP_POSITION, ToolTipWrapper } from '../tooltip'

import styles from './column.module.scss'
import Quince from './icons/quince.inline.svg'

export interface ColumnProps {
  className?: string
  header: React.ReactNode
  footer?: React.ReactNode
  smallerUpper?: boolean
  internalText: string
  upperHeight?: number
  showInfoTooltip?: boolean
  infoTooltipText?: string
}

const Column = ({
  className,
  header,
  footer,
  smallerUpper,
  internalText,
  upperHeight,
  showInfoTooltip,
  infoTooltipText,
}: ColumnProps) => {
  const classes = classnames(styles.column, className)
  const innerStyle = {
    height: (upperHeight && `${upperHeight}rem`) || (smallerUpper && '4.9rem'),
  }
  return (
    <div className={classes}>
      <div className={classnames('body1_ivy', styles.column__header)}>{header}</div>
      <div className={styles.column__upper} style={innerStyle}></div>
      <div className={styles.column__lower}>{internalText}</div>
      <div className={classnames(styles.column__footer, !footer && styles.column__footer__quince)}>
        {footer || <Quince className={styles.column__quince} />}
        {showInfoTooltip && (
          <div className={styles.column__footer__infoIcon}>
            <ToolTipWrapper
              topTipPosition={TOP_TIP_POSITION.TOP}
              toolTipContentRenderer={() => infoTooltipText}
              className={styles.column__footer__infoIcon__toolTipWrapper}
              toolTipContentClassName={styles.column__footer__infoIcon__toolTipContentWrapper}
            >
              <IButton />
            </ToolTipWrapper>
          </div>
        )}
      </div>
    </div>
  )
}

export default Column
